export var InquirySegmentationType;
(function (InquirySegmentationType) {
    InquirySegmentationType["Category"] = "category";
    InquirySegmentationType["InquiryFrequency"] = "inquiry_frequency";
    InquirySegmentationType["InquiryType"] = "inquiry_type";
    InquirySegmentationType["InquiryCategory"] = "inquiry_category";
    InquirySegmentationType["InquiryStatus"] = "inquiry_status";
})(InquirySegmentationType || (InquirySegmentationType = {}));
